import {provideAppInitializer, inject} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';
import {defineLocale} from 'ngx-bootstrap/chronos';
import {enGbLocale} from 'ngx-bootstrap/locale';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';
import {
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalService,
  MsalBroadcastService,
  MsalInterceptor
} from '@azure/msal-angular';
import {PublicClientApplication, InteractionType} from '@azure/msal-browser';
import {msalConfig, protectedResources} from './app/msal-config';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import { AuthUnauthorizedInterceptor } from './app/services/auth-unauthorized.interceptor';

defineLocale('en-gb', enGbLocale);

const msalInstance = new PublicClientApplication(msalConfig);
const authRedirectMarkerKey = 'auth.redirect.startedAt';

function clearStaleMsalInteractionLocks(): void {
  Object.keys(sessionStorage)
    .filter(k => k.endsWith('.interaction.status'))
    .forEach(k => sessionStorage.removeItem(k));
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []),
    provideAppInitializer(() => {
      const localeService = inject(BsLocaleService);
      localeService.use('en-gb');
    }),
    provideAppInitializer(async () => {
      try {
        await msalInstance.initialize();
        const result = await msalInstance.handleRedirectPromise({
          navigateToLoginRequestUrl: false
        });
        if (result?.account) {
          msalInstance.setActiveAccount(result.account);
        } else {
          const accounts = msalInstance.getAllAccounts();
          if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
          }
        }
      } finally {
        sessionStorage.removeItem(authRedirectMarkerKey);
        clearStaleMsalInteractionLocks();
      }
    }),
    {provide: MSAL_INSTANCE, useValue: msalInstance},
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useValue: {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map<string, Array<string>>([
          [protectedResources.api.endpoint, protectedResources.api.scopes]
        ])
      }
    },
    {provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: AuthUnauthorizedInterceptor, multi: true},
    MsalService,
    MsalBroadcastService
  ]
}).catch(err => console.error(err));
